import React from 'react';
import { Box, Grid, Avatar, Paper, Typography } from '@mui/material';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import { useCustomMediaQuery } from "../common/useCustomMediaQuery";
import { basicColor, themeColors } from "../common/colors";

interface CommentMessageProps {
  message: string;
}

const CommentMessage: React.FC<CommentMessageProps> = ({ message }) => (
  <Grid
    container
    spacing={2}
    alignItems="flex-start"
    m={0}
    p={0}
    sx={{ flexWrap: 'nowrap' }}
  >
    <Grid item sx={{ paddingTop: '0 !important' }} my={1}>
      <Avatar style={{ backgroundColor: '#fff', color: themeColors[0] }}>
        <SmartToyOutlinedIcon />
      </Avatar>
    </Grid>
    <Grid item sx={{ paddingTop: '0 !important' }} my={1}>
      <Paper
        elevation={3}
        style={{
          padding: '10px',
          background: basicColor,
          color: 'white',
          position: 'relative',
          borderRadius: '10px'
        }}
      >
        <Typography>{message}</Typography>
        <Box
          style={{
            position: 'absolute',
            top: '10px',
            left: '-10px',
            width: '0',
            height: '0',
            borderTop: '10px solid transparent',
            borderBottom: '10px solid transparent',
            borderRight: `10px solid ${themeColors[0]}`
          }}
        />
      </Paper>
    </Grid>
  </Grid>
);


const CommentMessages: React.FC<CommentMessageProps> = ({ message }) => {
  const { isDesktop } = useCustomMediaQuery();
  if (message && message.length > 0) {
    return (
      <Box py={0} px={2} mx={'auto'} mt={0} maxWidth={isDesktop ? 800 : 'auto'} style={{ backgroundColor: '#fff', color: 'white', borderRadius: '10px' }}>
        <CommentMessage message={message} />
      </Box>
    );
  }
  return null;
};


export default CommentMessages;